import ApplicationSerializer from 'eflex/serializers/application';

export default class WorkInstructionFolderSerializer extends ApplicationSerializer {
  attrs = {
    workInstructions: {
      serialize: false,
      deserialize: false,
    },
  };
}
